export const scrollToSection = (className, offset = 50) => {
    window.scrollTo({
        top: document.querySelector(`.${className}`).getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth',
    });
};
